<template>
    <v-dialog v-model="dialog" style="width: 100%;">
        <v-card>
            <v-container id="jobFaturamento" class="pdf-content">
                <div
                    style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <v-col cols="3">
                        <v-img src="@/assets/logo_delta.jpg" contain height="90" />
                    </v-col>
                    <v-col cols="9" class="text-right">
                        <h2 class="mb-0">
                            Lista de Faturamento
                        </h2>
                    </v-col>
                </div>

                <v-card outlined class="pa-10">
                    <v-row v-for="job in listJobs" :key="job._id" dense>
                        <v-col cols="12">
                            <strong>Job.:</strong> {{ job.code }}
                        </v-col>
                        <v-col cols="12" class="pa-4">

                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>Nota Fiscal</th>
                                        <th>Emissão</th>
                                        <th>Valor da Nota</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="nota in notaFiscalList" :key="nota.numero">
                                        <th>
                                            {{ nota.numero }}
                                        </th>
                                        <th>
                                            {{ nota.emissao }}
                                        </th>
                                        <th>
                                            R$ {{ nota.valor.toFixed(2) }}
                                        </th>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-footer padless>
                                <v-row class="w-100 ma-0">
                                    <v-col cols="6" class="text-right font-weight-bold">Total Faturado:</v-col>
                                    <v-col cols="6">
                                    R$ {{ notaFiscalList.reduce((acc, nota) => acc + nota.valor, 0).toFixed(2) }}
                                    </v-col>
                                </v-row>
                                <v-row class="w-100 ma-0">
                                    <v-col cols="6" class="text-right font-weight-bold">Saldo a Faturar:</v-col>
                                    <v-col cols="6">R$ 500.00</v-col>
                                </v-row>
                            </v-footer>

                        </v-col>
                    </v-row>
                </v-card>
            </v-container>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>   
                <v-btn color="primary" @click="exportPdf">Gerar PDF</v-btn>    
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>

<script>
import html2pdf from 'html2pdf.js'
import Vue from 'vue';

export default {
    name: 'JobFaturamentoView',
    props: ['listJobs', 'open'],
    data() {
        return {
            dialog: false,
            notaFiscalList: [
                { numero: '12345', emissao: '01/01/2024', valor: 1500.00 },
                { numero: '67890', emissao: '15/01/2024', valor: 2500.00 },
                { numero: '11223', emissao: '20/01/2024', valor: 3500.00 },
            ]
        }
    },

    methods: {

        exportPdf(){
            const elemento = document.getElementById("jobFaturamento");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Faturamento.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(elemento)
            .save();
        },

        async getFisDocEmi(){
            await Vue.prototype.$http.get("/Entity/FisDocEmiItem", {
                params: {
                    statusEmissao: "EMITIDA",
                    job: this.listJobs.map(job => job._id).join(",")
                }
            })
        }
    },

    watch: {
        open(value){
            this.dialog = value

            if(value){
                this.getFisDocEmi()
            }
        }
    }
}
</script>

<style scoped>
.pdf-content {
  font-family: 'Arial', sans-serif;
  padding: 20px;
}

.avoid-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

tr {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
  font-size: 20px;
}
</style>
